import {Styles} from "../Styles";
import {CreateSquad} from "../Sections/CreateSquad";
import {CurrentPlayer} from "../Sections/CurrentPlayer";
import React, {useMemo} from "react";
import useGlobalSettings from "../../../Provider/useGlobalSettings";
import {iActivePlayer} from "../Squad";
import {SquadCard} from "../SquadCard";
import useSquad from "../../../Provider/useSquad";

const Result = () => {

	const { squads } = useSquad();

	return squads.length === 0 ? (
		<Styles.EmptyState>
			Noch keine Squads vorhanden. Erstelle dein erstes Einsatzteam.
		</Styles.EmptyState>
	) : (
		<Styles.Grid>
			{
				squads
					.map( squad => <SquadCard squadID={ squad.id } /> )
			}
		</Styles.Grid>
	)
}

export const Create = () => {

	return <Styles.Page>

		<Styles.CommandPanel>
			<CreateSquad />
		</Styles.CommandPanel>

		<Result />
	</Styles.Page>
}